module.exports = __webpack_public_path__ + "img/lubrico_warranty.c584580f.png";